import {
    FOREGROUND_STYLES,
    resolveColorContext,
    type ContextFamily,
    type ContextTone,
} from '@quipex/shared/utils';

export function resolveTypographyClass(
    family: ContextFamily | undefined,
    tone: ContextTone,
    decorative: boolean
): string {
    if (!family) return FOREGROUND_STYLES.ordinary.className;
    const colors = resolveColorContext(family, tone);
    return (decorative ? colors.decorative : colors.foreground).className;
}
